import { render } from "./BarqGrid.vue?vue&type=template&id=94ebadc0&scoped=true"
import script from "./BarqGrid.vue?vue&type=script&lang=js"
export * from "./BarqGrid.vue?vue&type=script&lang=js"

import "./BarqGrid.vue?vue&type=style&index=0&id=94ebadc0&scoped=true&lang=css"

import exportComponent from "/Users/alexmeister/Documents/GitHub/barq2_0_new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94ebadc0"]])

export default __exports__